import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Grid } from "@mui/material";
import { BACKEND_BASE_URL, BASE_URL, isEmpty, printDebugLog, SUCCESS } from "../../constants/Constants";
import axios from "axios";
import CommonUtils from "../../utilities/CommonUtils";
import ConfirmDialog from "../../global/ConfirmDialog";
import { useLocation, useNavigate } from "react-router-dom";

const CustomerBillSection = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const INITIAL_DIALOG = {
        showDialog: false,
        title: "",
        subTitle: "",
        negativeReq: false,
        negativeAction: "",
        positiveReq: false,
        positiveAction: "",
        onDialogClose: () => { },
        handleSubmit: () => { },
        onCancel: () => { },
    };

    const INITIAL_BILL_INFO = {
        shopName: "",
        bookingId: "",
        info: "",
        txnId: "",
        printPath: "",
    };

    const [dialogComponent, setDialogComponent] = useState(INITIAL_DIALOG)

    const [billInfo, setBillInfo] = useState(INITIAL_BILL_INFO)

    const handleDismiss = () => {
        setDialogComponent(INITIAL_BILL_INFO);
        window.location.href = "https://billmitra.com/";
    }

    useEffect(() => {
        printDebugLog("CustomerBillSection: useEffect");
        const queryParams = new URLSearchParams(location.search);
        const refBillId = queryParams.get('q');
        if (!isEmpty(refBillId)) {
            getSuccessBillDetails(refBillId);
        } else {
            setDialogComponent(prev => ({
                ...prev,
                showDialog: true, title: "Expired!", subTitle: "This link is expired!", negativeAction: "Ok!", negativeReq: true,
                onDialogClose: handleDismiss,
                onCancel: handleDismiss,
            }))
        }
        navigate(location.pathname, { replace: true });
    }, []);

    const getSuccessBillDetails = async (refBillId) => {
        try {
            const response = await axios.get(`${BACKEND_BASE_URL}get-success-booking?id=${CommonUtils.encode(refBillId)}`);
            printDebugLog("getSuccessBillDetails", response.data);
            if (response.data.status === SUCCESS) {
                if (isEmpty(response.data.payLoad.printPath)) {
                    setDialogComponent(prev => ({
                        ...prev,
                        showDialog: true, title: "Expired!", subTitle: "This link is expired!", negativeAction: "Ok!", negativeReq: true,
                        onDialogClose: handleDismiss,
                        onCancel: handleDismiss,
                    }));
                    return;
                }
                setBillInfo(prev => ({
                    ...prev, ...response.data.payLoad,
                }))
            } else {
                setDialogComponent(prev => ({
                    ...prev,
                    showDialog: true, title: "Expired!", subTitle: "This link is expired!", negativeAction: "Ok!", negativeReq: true,
                    onDialogClose: handleDismiss,
                    onCancel: handleDismiss,
                }))
            }
        } catch (err) {
            console.error("getSuccessBillDetails", err);
        }
    }

    return (
        <Box sx={{ p: 2 }}>
            {/* Info Section */}
            <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Hotel Name
                        </Typography>
                        <Typography variant="h6">{billInfo.shopName}</Typography>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Invoice #
                        </Typography>
                        <Typography variant="h6">{billInfo.bookingId}</Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Payment Information
                        </Typography>
                        <Typography variant="h6" noWrap>
                            {billInfo.info}
                        </Typography>
                    </Grid>
                    {
                        !isEmpty(billInfo.txnId) && <Grid item xs={12}>
                            <Typography variant="subtitle2" color="text.secondary">
                                Transaction Id
                            </Typography>
                            <Typography variant="h6" noWrap>
                                {billInfo.txnId}
                            </Typography>
                        </Grid>
                    }
                    <Grid item xs={12}>
                        <Typography variant="p" color="red">
                            Please download this bill, once the browser is closed/inactive , all data will be lost.
                        </Typography>
                    </Grid>
                    {/* <Grid item xs={12}>
                        <Typography
                            variant="body2"
                            style={{
                                whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word',
                                color: '#25c9f3ff',
                                fontSize: '12px',
                            }}
                        >
                            <em>
                                powered By{' '}
                                <a
                                    href="https://billmitra.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: '#5f6566ff', textDecoration: 'underline' }}
                                >
                                    A2z Unit SNP Pvt. Ltd
                                </a>
                                {' '}ISO 9001-2008 certified.
                            </em>
                        </Typography>
                    </Grid> */}
                </Grid>
            </Paper>

            {/* PDF Viewer */}
            {
                !isEmpty(billInfo.printPath) &&
                <Box
                    sx={{
                        width: "100%",
                        height: { xs: "70vh", md: "80vh" },
                        border: "1px solid #ccc",
                        borderRadius: 2,
                        overflow: "hidden",
                    }}
                >
                    <iframe
                        src={`${BASE_URL}/files/${billInfo.printPath}`}
                        title="Booking PDF"
                        width="100%"
                        height="100%"
                        style={{ border: "none" }}
                    />
                </Box>
            }
            <ConfirmDialog isOpen={dialogComponent.showDialog}
                title={dialogComponent.title}
                subTitle={dialogComponent.subTitle}
                negativeReq={dialogComponent.negativeReq}
                negativeAction={dialogComponent.negativeAction}
                positiveReq={dialogComponent.positiveReq}
                iconReq={false}
                positiveAction={dialogComponent.positiveAction}
                onClose={dialogComponent.onDialogClose}
                onSubmit={dialogComponent.handleSubmit}
                onCancel={dialogComponent.onCancel}
            />
        </Box>

    );
};

export default CustomerBillSection;
